import { Link } from "react-router-dom";
import ErrorPage from "../../../../Layouts/Error";
import InnerHeader from "../../../../Layouts/InnerHeader";
import Loading from "../../../../Layouts/Loading";
import { TourRequest, useCreateTourMutation, useDeleteTourMutation, useGetAllToursQuery, useLazyGetTourQuery, useUpdateTourMutation } from "../../../../Redux/Apis/ebroApi";
import { fa_currency, fa_date, fa_number } from "../../../../utils/Persian";
import { useEffect, useState } from "react";
import { toast } from "react-toastify"

export default function Tournament(){
    const [deleteTour] = useDeleteTourMutation()
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetAllToursQuery()

    const [create,{isLoading : isCreateTourLoading}] = useCreateTourMutation()
    const [update,{isLoading : isUpdateTourLoading}] = useUpdateTourMutation()

    const [errorMsg, setErrorMsg] = useState<any>(false)
    const [isUpdate, setIsUpdate] = useState(false)
    
    const [formState, setFormState] = useState<TourRequest>({
        name: "",
        price: NaN,
        status: ""
    })

    const [ loadTour , {data: tour, isSuccess: isTourSuccess}] = useLazyGetTourQuery()
    useEffect(() => {
        if(isTourSuccess && tour) setFormState({id: tour.id, name: tour.name,price: +tour.price, status: tour.status })
    },[isTourSuccess,tour])

    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const handleNumChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: +value }))

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            if(isUpdate) {
                await update(formState).unwrap();
                toast.success('مسابقه با موفقیت ویرایش گردید');
            }
            else {
                await create(formState).unwrap();
                toast.success('مسابقه با موفقیت ایجاد شد');
            }
            setIsUpdate(false)
            setFormState({name:"",price:NaN,status:""})
            setErrorMsg(false) 
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }
    
    if(isLoading)
        return <Loading/>

    else if(isError)
        return <ErrorPage data={error}/>

    else if(isSuccess)
        return(
            <div className="container-lg">
                <InnerHeader name="مسابقات ابرو"/>
                {errorMsg && <div className="alert alert-danger" role="alert">
                    {errorMsg}
                </div>}
                <div className="row">
                    <form id="CatForm" onSubmit={onSubmit} className="row row-cols-lg-auto g-3 align-items-center border-top border-bottom p-0 m-0 pb-3 px-3 mb-4 shadow-sm bg-body-tertiary">
                        <div className="col-12">
                        <i className="fas fa-calendar-plus text-secondary"></i>
                        </div>
                        <div className="col-12">
                            <label className="visually-hidden" htmlFor="name">نام مسابقه</label>
                            <input type="text" className="form-control" value={formState.name} onChange={handleChange} name="name" id="name" placeholder="نام مسابقه"/>
                        </div>

                        <div className="col-12">
                            <label className="visually-hidden" htmlFor="price">هزینه ثبت نام</label>
                            <input type="number" className="form-control" min={0} max={9999999999} step={1} lang="en" onChange={handleNumChange} value={Number.isNaN(formState.price) ? "" : formState.price} name="price" id="price" placeholder="هزینه ثبت نام" style={{direction:"rtl"}}/>
                        </div>

                        <div className="col-12">
                            <label className="visually-hidden" htmlFor="status">وضعیت</label>
                            <select name='status' onChange={(e) => setFormState((prev) => ({ ...prev, 'status': e.target.value }))} value={formState.status} className="form-select" id="status">
                                <option>انتخاب وضعیت</option>
                                <option value="ACTIVE">فعال</option>
                                <option value="DEACTIVE">غیر فعال</option>
                            </select>
                        </div>

                        <div className="col-12">
                            <button type="submit" disabled={isCreateTourLoading || isUpdateTourLoading} className={`btn w-100 ${isUpdate ? "btn-primary" : "btn-success"}`}>{isUpdate ? "ویرایش" : "ایجاد مسابقه جدید"} </button>
                        </div>
                    </form>
                    {data && data.length > 0 ? 
                    <div className="table-responsive"><table className="table">
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">نام مسابقه</th>
                            <th scope="col">هزینه ثبت نام</th>
                            <th scope="col">تاریخ ایجاد</th>
                            <th scope="col">وضعیت</th>
                            <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {data.map((value:any,index:number) => 
                            <tr key={index}>
                                <th scope="row">{fa_number(index+1)}</th>
                                <td>{value.name}</td>
                                <td>{fa_currency(+value.price)}</td>
                                <td>{fa_date(value.create_date)}</td>
                                <td className={`${value.status === "ACTIVE" ? "text-success" : "text-danger"}`}>{value.status === "ACTIVE" ? "فعال" : "غیر فعال"}</td>
                                <td>
                                    <div className="d-grid gap-2 d-md-block justify-content-md-end">
                                        <Link to={`/ebro-tours/signups/${+value.id}/${value.name}`}
                                            className="btn btn-outline-secondary me-md-2"
                                            role="button"
                                            style={{textDecoration:'none'}}>
                                            <i className='zmdi zmdi-info'></i> مشاهده ثبت‌نام ها
                                        </Link>
                                        <a href="#CatForm" type="button" onClick={() => {loadTour(value.id); setIsUpdate(true)}} className="btn btn-outline-primary me-md-2">ویرایش</a>
                                        <button 
                                            onClick={() => window.confirm('آیا از حذف کامل این مسابقه اطمینان دارید؟ \n\n (از بخش ویرایش امکان غیر فعال سازی ثبت نام مسابقه وجود دارد)') &&  deleteTour(value.id)} 
                                            className="btn btn-danger"><i className="fas fa-trash"></i> حذف</button>
                                    </div>
                                </td>
                            </tr>
                            )}
                        </tbody>
                    </table></div>
                    :
                    <div className="alert d-flex align-items-center" role="alert">
                        <i className="zmdi zmdi-info"></i>
                        <div className="ms-2">
                            مسابقه ای یافت نشد.
                        </div>
                    </div>
                    }
                </div>
            </div>
        )

    else return <></>
}